<template>
	<div class="mg-b-10 mg-lg-b-15 mg-xl-b-0">
		<div v-if="loading">
			<spinner-component :loading="loading"/>
		</div>

		<div v-if="error" class="tx-center tx-danger">
			{{ error }}
		</div>

		<div v-else class="row justify-content-center">
            <div v-if="!loading && executive_information" class="col-md-6 mb-0">
                <alert-success :form="form" :class="'shadow-sm'" message="Your changes have been saved!"></alert-success>
				<approval-alert-component :hasPendingApproval="executive_information.hasPendingApproval"></approval-alert-component>

                <h3 class="tx-color-01 mg-b-10">Executive Information</h3>
                <p class="tx-color-03 mg-b-10">Please provide us with your company's executive details.</p>

                <form class="row" @submit.prevent="save">
                    <div class="form-group col-12">
						<label>CEO</label>
						<input v-model="form.ceo" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('ceo') }" placeholder="Enter company's ceo" required>
						<has-error :form="form" field="ceo"></has-error>
					</div>
                    <div class="form-group col-12">
						<label>Secretary</label>
						<input v-model="form.secretary" type="text" class="form-control shadow-sm" :class="{ 'is-invalid': form.errors.has('secretary') }" placeholder="Enter company's secretary" required>
						<has-error :form="form" field="secretary"></has-error>
					</div>
                    <div class="form-group col-12">
						<label class="wd-100p">
                            Board of Directors
                            <a href="#update-board" data-toggle="modal" class="float-right">{{ (form.board_of_directors.length) ? 'Update List' : 'Add Director'}}</a>
                        </label>
						<ul class="list-group shadow-sm">
                            <li class="list-group-item" v-for="(person, index) in form.board_of_directors" :key="index">{{ person }}</li>
                        </ul>
						<has-error :form="form" :class="'d-block'" field="board_of_directors"></has-error>
					</div>
					
					<div class="col-12 border-top mt-3">
						<button-component :busy="form.busy" :label="'Save'" :label-loading="'Saving changes...'" :button-class="'btn btn-default float-right mt-3 shadow-sm'"></button-component>
					</div>
				</form>

                <update-board-of-directors-component :backdrop="false" :board="form.board_of_directors" @update-board="updateBoard"></update-board-of-directors-component>
            </div>
        </div>
	</div>
</template>

<style scoped>
	@media (max-width: 425px) {
		.hide {
			display: none;
		}
	}
</style>

<script>
	export default {
		data() {
			return {
				loading: false,
				error: null,
				options: null,
				executive_information: null,
				form: new Form({
					type_id: null,
					ceo: null,
					board_of_directors: [],
					secretary: null,
				}),
			};
		},
		created() {
			this.fetchProfessionInformation();
		},
		watch: {
			$route: "fetchProfessionInformation",
		},
		methods: {
			updateBoard(list) {
				this.form.board_of_directors = list;
			},
			fetchProfessionInformation() {
				const { external_client_id } = this.$store.getters.company;
				this.error = null;
				this.loading = true;

				axios
					.get(`/api/profession-information/${external_client_id}`)
					.then((response) => {
						this.executive_information =
							response.data.data.profession_information;

						if (!_.isEmpty(this.executive_information)) {
							const {
								ceo,
								board_of_directors: bod,
								secretary,
							} = this.executive_information;

							const board_of_directors = !_.isEmpty(bod)
								? JSON.parse(board_of_directors)
								: [];

							this.form.fill({
								ceo,
								board_of_directors,
								secretary,
								external_client_id,
							});
						}
					})
					.catch(({response}) => {
						console.log(response);
						// this.error = error.toString();
					})
					.finally(() => {
						this.loading = this.refresh = false;
					});
			},
			save() {
				this.form
					.patch(
						`/api/companies/${this.$store.getters.company.external_client_id}`,
						{
							params: {
								type: "executive_information",
							},
						}
					)
					.then()
					.catch(({response}) => (console.log(response)))
					.finally(() => {
						window.scrollTo(0, 0);
					});
			},
		},
	};
</script>
